import l10n from "@/services/l10n";
import AccessControl from "@/services/AccessControl";

import { USER_GROUP_PERSON } from "@/constants";

export default [
  {
    name: "albumCreate",
    path: "/albums/create",
    icon: "albums",
    meta: { title: l10n("ADD_ALBUM") },
    beforeEnter: AccessControl.route(USER_GROUP_PERSON),
    component: () =>
      import(
        /* webpackChunkName: "showcase" */ "@/pages/Albums/AlbumCreate.vue"
      )
  },
  {
    name: "albums",
    path: "/albums",
    icon: "albums",
    meta: { title: l10n("ALBUMS") },
    component: () =>
      import(/* webpackChunkName: "albums-list" */ "@/pages/Albums/Albums.vue")
  },
  {
    name: "popularAlbums",
    path: "/albums/popular",
    icon: "albums",
    meta: { title: l10n("POPULAR_ALBUMS") },
    component: () =>
      import(
        /* webpackChunkName: "albums-list" */ "@/pages/Albums/AlbumsPopular.vue"
      )
  },
  {
    name: "latestAlbums",
    path: "/albums/latest",
    icon: "albums",
    meta: { title: l10n("LATEST_ALBUMS") },
    component: () =>
      import(
        /* webpackChunkName: "albums-list" */ "@/pages/Albums/AlbumsLatest.vue"
      )
  },
  {
    name: "favoriteAlbums",
    path: "/albums/favorite",
    icon: "albums",
    meta: { title: l10n("FAVORITES_ALBUMS") },
    beforeEnter: AccessControl.route(USER_GROUP_PERSON),
    component: () =>
      import(
        /* webpackChunkName: "albums-list" */ "@/pages/Albums/AlbumsFavorite.vue"
      )
  },
  {
    name: "releatedAlbums",
    path: "/albums/:id/releated",
    icon: "albums",
    meta: { title: l10n("RELEATED_ALBUMS") },
    component: () =>
      import(
        /* webpackChunkName: "albums-list" */ "@/pages/Albums/AlbumsReleated.vue"
      )
  },
  {
    name: "albumEdit",
    path: "/albums/:id/edit",
    icon: "albums",
    meta: { title: l10n("EDIT_ALBUM") },
    // beforeEnter: authenticatedAlbumOwner,
    component: () =>
      import(/* webpackChunkName: "editor" */ "@/pages/Albums/AlbumEdit.vue")
  },
  {
    name: "albumReview",
    path: "/albums/:id/review",
    icon: "albums",
    meta: { title: l10n("ALBUM"), type: "review" },
    component: () =>
      import(/* webpackChunkName: "fullview" */ "@/pages/Albums/Album.vue")
  },
  {
    name: "album",
    path: "/albums/:id",
    icon: "albums",
    meta: { title: l10n("ALBUM"), type: "default" },
    component: () =>
      import(/* webpackChunkName: "fullview" */ "@/pages/Albums/Album.vue")
  }
];
